import {
    BaseLayer,
    BaseLayerFactory_27700,
    BaseLayerType
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import { Tile } from "ol";
import TileLayer from "ol/layer/Tile";
import TileGrid from "ol/tilegrid/TileGrid";
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import TileWMS from 'ol/source/TileWMS';


//declare module 'esdm-map/dist/baselayers/BaseLayerType' {
//    export enum BaseLayerType {
//        BucksOS = 999,
//        BucksAerial = 1000
//    }
//}

export const BucksBaseLayers = {
    ...BaseLayerType,
    BucksOS : 999,
    BucksAerial: 1000,
    BucksHistoricRidgeAndFurrow: 1001,
    BucksOS1stEdition: 1002
};

export class CustomClient_BaseLayerFactory_27700 extends BaseLayerFactory_27700 {

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string = "", esdmApiKey: string = ""): IBaseLayer {
        if (baseLayerType === BucksBaseLayers.BucksOS) {
            return this.GetBucksOS();
        } else if (baseLayerType === BucksBaseLayers.BucksAerial) {
            return this.GetBucksAerial();
        } else if (baseLayerType === BucksBaseLayers.BucksHistoricRidgeAndFurrow) {
            return this.HistoricRidgeAndFurrow();
        } else if (baseLayerType === BucksBaseLayers.BucksOS1stEdition) {
            return this.BucksOS1stEdition();
        }
        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmApiKey);
    }

    
    private GetBucksOS(): IBaseLayer {

        let lyr = new TileLayer({
            visible: false,
            source: new WMTS({                               
                url: 'https://maps.buckscc.gov.uk/arcgis/rest/services/Bucks_Basemapping/MapServer/WMTS/',
                layer: 'Bucks_Basemapping',
                matrixSet: 'default028mm',
                format: 'image/png',
                projection: 'EPSG:27700',
                tileGrid: new WMTSTileGrid({
                    origin: [-5220400,4470200],
                    resolutions: [264.58386250102507, 132.29193125051253, 66.14596562525627, 33.07298281262813, 16.933367200065604, 8.466683600032802, 4.233341800016401, 2.1166709000082005, 1.0583354500041002, 0.5291677250020501, 0.26458386250102506],
                    matrixIds:  ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
                }),
                style: 'default',
                wrapX: false, 
                crossOrigin: "Anonymous",
                attributions: `OS mapping: © Crown copyright OS 0100062456. You are granted a non-exclusive, royalty free, revocable licence solely to view the Licensed Data for non-commercial purposes for the period during which Buckinghamshire Council makes it available. You are not permitted to copy, sub-license, distribute, sell or otherwise make available the Licensed Data to third parties in any form. Third party rights to enforce the terms of this licence shall be reserved to OS.`                
            })
        })
        return new BaseLayer("BucksCustom", "Ordnance Survey", lyr);        
    }


    private GetBucksAerial(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                urls: ["/api/ogcservice/BucksAerial"],
                params: {
                    LAYERS: 'APGB_Latest_UK_250mm',
                    TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",                
                crossOrigin: "Anonymous",
                attributions: "Aerial photography: © Getmapping plc. <a href='www.getmapping.com' target='_blank'>www.getmapping.com</a>"
            })
        })
        return new BaseLayer("BucksCustomAerial", "Aerial Photography", lyr);
    }

    private HistoricRidgeAndFurrow(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                urls: ["/api/ogcservice/BucksHistoric"],
                params: {
                    LAYERS: '1',
                    TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",     
                crossOrigin: "Anonymous",
                attributions: `<p>© Crown copyright 2020 Ordnance Survey 0100062456 Use of this data is subject to terms and conditions. You are granted a non-exclusive, royalty free, revocable licence solely to view the Licensed Data for non-commercial purposes for the period during which Buckinghamshire Council makes it available; You are not permitted to copy, sub-license, distribute, sell or otherwise make available the Licensed Data to third parties in any form; Third party rights to enforce the terms of this licence shall be reserved to Ordnance Survey</p>
<p>© Copyright Buckinghamshire Council Historic Environment Record 2020.</p>`                        
            })
        })
        return new BaseLayer("HistoricRidgeAndFurrow", "Historic ridge and furrow", lyr);
    }

    private BucksOS1stEdition(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                urls: ["/api/ogcservice/BucksHistoric"],
                params: {
                    LAYERS: '11,12',
                    TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",                
                crossOrigin: "Anonymous",
                attributions: "©Landmark Information Group"                        
            })
        })
        return new BaseLayer("BucksOS1stEdition", "OS 1st edition (1876-1885)", lyr);
    }
}